import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Import useLocation
import { getListaEvasione, getDatiAzienda } from '../services/api';
import { Container, Spinner, Alert, Table } from 'react-bootstrap';
import '../print.css';

function ListaEvasionePrint() {
  const navigate = useNavigate();
  const location = useLocation(); // Use useLocation hook
  const [listaEvasione, setListaEvasione] = useState([]);
  const [datiAzienda, setDatiAzienda] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const queryParams = new URLSearchParams(location.search);
        const ordineIdsParam = queryParams.get('ordine_ids');
        let ordineIds = [];
        if (ordineIdsParam) {
          ordineIds = ordineIdsParam.split(',').map(id => parseInt(id, 10));
        }

        const [listaResponse, aziendaResponse] = await Promise.all([
          getListaEvasione(ordineIds, 'ubicazione,item_name', 'asc,asc'), // Pass selected order IDs with sorting
          getDatiAzienda()
        ]);
        setListaEvasione(listaResponse.data);
        setDatiAzienda(aziendaResponse.data);
      } catch (err) {
        setError('Errore nel caricamento dei dati per la lista di evasione.');
        console.error("Errore dettagliato nel caricamento:", err);
        if (err.response) {
          console.error("Dettagli errore response:", err.response);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [location.search, navigate]); // Depend on location.search and navigate to re-fetch if query params change

  useEffect(() => {
    const handleAfterPrint = () => {
      setTimeout(() => {
        navigate('/ordini'); // Reindirizza alla pagina degli ordini dopo la stampa
      }, 100);
    };

    if (!loading && !error && datiAzienda && listaEvasione.length > 0) {
      window.addEventListener('afterprint', handleAfterPrint);
      window.print();
    }

    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, [loading, error, datiAzienda, listaEvasione, navigate]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Preparazione stampa lista di evasione...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
        <p>Impossibile preparare la stampa.</p>
      </Container>
    );
  }

  if (!datiAzienda || listaEvasione.length === 0) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">Nessun ordine da evadere trovato o dati aziendali mancanti.</Alert>
      </Container>
    );
  }

  return (
    <div id="printable-area" className="portrait-page">
      <div className="print-container">
        <header className="print-header">
          <div className="company-details">
            {datiAzienda.logo_url && (
              <img
                src={`${process.env.REACT_APP_STATIC_FILES_BASE_URL}${datiAzienda.logo_url}`}
                alt="Logo Azienda"
                style={{ maxHeight: '150px', maxWidth: '150px', marginRight: '20px', objectFit: 'contain' }}
              />
            )}
          </div>
          <div className="print-info">
            <p><strong>Data di Stampa:</strong> {new Date().toLocaleDateString()}</p>
            <p><strong>Lista Evasione Ordini</strong></p>
          </div>
        </header>

        <main>
          <h2 className="document-title">Lista Evasione Ordini</h2>

          <section className="print-section">
            <div className="print-section-content" style={{ padding: '0' }}>
              <Table className="print-table mb-0">
                <thead>
                  <tr>
                    <th>BARCODE</th>
                    <th>TITOLO/DESCRIZIONE</th>
                    <th className="text-right">QT.</th>
                    <th>UBICAZIONE</th>
                    <th>CLIENTE</th>
                  </tr>
                </thead>
                <tbody>
                  {listaEvasione.map((item, index) => (
                    <tr key={index}>
                      <td>{item.item_barcode || 'N/A'}</td>
                      <td>{item.item_name || item.item_descrizione || 'N/A'}</td>
                      <td className="text-right">{item.quantita_richiesta}</td>
                      <td>{item.ubicazione || 'N/A'}</td>
                      <td>
                        {item.cliente_denominazione || 
                         (item.cliente_nome && item.cliente_cognome ? `${item.cliente_nome} ${item.cliente_cognome}` : 'N/A')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </section>
        </main>

        <footer className="print-footer">
          <p>{datiAzienda.denominazione} - {datiAzienda.indirizzo} - {datiAzienda.cap} {datiAzienda.citta} ({datiAzienda.provincia}) - P.IVA {datiAzienda.piva}</p>
          <p>Email: {datiAzienda.email} - Tel: {datiAzienda.tel}</p>
        </footer>
      </div>
    </div>
  );
}

export default ListaEvasionePrint;